import React from 'react';
import { Link } from 'react-router-dom';

export default function LoginFooter({ version, date }) {
  return (
    <>
      <div className="mt-6 space-y-3 text-center text-sm">
        <Link to="/forgot-password" className="text-primary hover:underline block" data-testid="forgot-password-link">
          Forgot password?
        </Link>
        <div className="text-muted-foreground">
          Don't have an account?{' '}
          <Link to="/signup" className="text-primary hover:underline font-medium" data-testid="signup-link">Sign up</Link>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t text-center text-xs text-muted-foreground">
        <div className="flex justify-center gap-3">
          <Link to="/terms-of-service" className="hover:text-primary hover:underline" data-testid="terms-link">Terms</Link>
          <span>•</span>
          <Link to="/privacy-policy" className="hover:text-primary hover:underline" data-testid="privacy-link">Privacy</Link>
          <span>•</span>
          <Link to="/license-agreement" className="hover:text-primary hover:underline" data-testid="license-link">License</Link>
        </div>
        <div className="mt-3 text-[11px] text-muted-foreground/80" data-testid="platform-version">
          SAFER-i™ Platform · {version || 'v…'}{date ? ` · ${date}` : ''}
        </div>
      </div>
    </>
  );
}
